import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './woodmetalfinishing.css';

const WoodMetalFinishing = () => {
  const imagePaths = [
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_02.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_03.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_04.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_05.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_06.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_07.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_08.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_09.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_10.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_11.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_12.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_13.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_14.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_15.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_16.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_17.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_18.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_19.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_20.jpg",
    "/images/Wood%20and%20Metal%20Finishing/Refinishing_21.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);

  // Preload images
  useEffect(() => {
    imagePaths.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [imagePaths]);

  const nextImage = () => {
    setLoaded(false);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imagePaths.length);
      setLoaded(true);
    }, 300);
  };

  const prevImage = () => {
    setLoaded(false);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + imagePaths.length) % imagePaths.length);
      setLoaded(true);
    }, 300);
  };

  // Auto change every 6 seconds
  useEffect(() => {
    setLoaded(true);
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="woodmetalfinishing-container">
      <Link to="/" className="home-button">Home</Link>

      <div className="image-frame">
        <div className="text-container">
          <h2>
            <div className="title-gc">Wood & Metal Finishing</div>
          </h2>
          <p>
            <div className="text-blurb">
              Traditional Line’s finishing department is skilled in all types of traditional and modern wood finishes including French polishing, historic finishes, and gilding.
            </div>
          </p>
        </div>

        <div className="slideshow-container">
          <img
            src={imagePaths[currentIndex]}
            alt={`Wood and Metal Finishing ${currentIndex + 1}`}
            className={`woodmetalfinishing-image ${loaded ? 'loaded' : 'loading'}`}
          />
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
};

export default WoodMetalFinishing;
